import type { Sequence } from "../types/Sequence"

export function Any<T>(
  iterable: Sequence<T>,
  func: (item: T) => boolean = a => (a ? true : false)
) {
  for (const t of iterable) {
    if (func(t)) return true
  }
  return false
}
